// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2pW88","inputWrap":"CustomTip_inputWrap__2_O2W"};